<template>
  <div v-if="this.ready == false" class="container-scroller neu-bg">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth px-0">
        <div class="row w-100 mx-0">
          <div class="col-lg-4 mx-auto carta">
            <!-- Card neumorphism -->
            <div class="auth-form-light neu-card">
              <!-- Avatar / Logo circular -->
              <div class="neu-avatar-wrap">
                <div class="neu-avatar">
                  <img src="../../public/images/logo-mini-sin.png" alt="logo"  class="w-50"/>
                </div>
              </div>

              <div class="text-center mt-3">
                <h4 class="neu-title">AHDECO</h4>
                <p class="neu-subtitle">Accede a tu sistema</p>
              </div>

              <form-tag-login
                @my-event="submitHandler"
                name="myform"
                event="my-event"
                class="pt-3"
              >
                <!-- Email -->
                <div class="form-group neu-input">


                  <text-input
                    v-model="email"
                    type="email"
                    name="email"
                    placeholder="Email"
                    required="true"
                    icon="user"
                  >
                  </text-input>
                </div>

                <!-- Password -->
                <div class="form-group neu-input">

                  <text-input
                    v-model="password"
                    type="password"
                    name="password"
                    placeholder="Contraseña"
                    required="true"
                    icon="lock"
                  >
                  </text-input>
                </div>

                <!-- Button -->
                <div class="mt-4">
                  <input
                    type="submit"
                    class="btn btn-primary btn-lg w-100 neu-btn text-white"
                    value="Iniciar Sesión"
                  />
                </div>

                <!-- Extra text (opcional) -->
                <div class="mt-3 text-center neu-foot">
                  <a href="https://ahdecohn.org" class="neu-muted">Ir a Página Web</a>
                </div>
              </form-tag-login>
            </div>
          </div>
        </div>
      </div>
      <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>

  <div v-else class="container-scroller">
    <!-- Aqui va Nav -->
    <header-app />

    <!-- partial -->
    <div class="container-fluid page-body-wrapper">
      <!-- partial:partials/_sidebar.html -->
      <NavbarLate />

      <!-- NuevoSolicitante -->
      <router-view v-slot="{ Component }" :key="componentKey" @forceUpdate="forceUpdate">
        <component :is="Component"></component>
      </router-view>

      <!-- main-panel ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>
</template>

<script>
import { store } from "./store.js";
import router from "./../router/index.js";
import Security from "./security.js";
import TextInput from "./forms/Text-Input-Login.vue";
// import notie from "notie"
import FormTagLogin from "./forms/FormTagLogin.vue";
import DashboardApp from "./../components/Body-App.vue";
import HeaderApp from "./../components/Header-App.vue";
import NavbarLate from "./../components/Navbar-Lateral.vue";
import Swal from "sweetalert2";

const getCookie = (name) => {
  return document.cookie.split("; ").reduce((r, v) => {
    const parts = v.split("=");
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, "");
};

export default {
  name: "LoginApp",
  data() {
    return {
      email: "",
      password: "",
      store,
      componentKey: 0,
      ready: false,
    };
  },
  components: {
    TextInput,
    FormTagLogin,
    DashboardApp,
    HeaderApp,
    NavbarLate,
  },
  beforeMount() {
    // Check Existing token
    Security.checkToken;
    // check for a cookie
    let data = getCookie("_site_data");

    if (data !== "") {
      // Security.requireToken();

      let cookieData = JSON.parse(data);

      //update store
      store.token = cookieData.token.token;
      store.user = {
        id: cookieData.user.id,
        first_name: cookieData.user.first_name,
        last_name: cookieData.user.last_name,
        email: cookieData.user.emailz,
      };
      console.log(`This is the name en APP ${cookieData.user.first_name}`);

      if (Security.checkTokenValid) {
        this.ready = true;
      } else this.ready = false;
    }
  },
  methods: {
    forceUpdate() {
      this.componentKey += 1;
    },

    submitHandler() {
      const payload = {
        email: this.email,
        password: this.password,
      };

      fetch(process.env.VUE_APP_API_URL + "/users/login", Security.requestOptions(payload))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            Swal.fire({
              icon: "error",
              title: "Correo o Contraseña Incorrecta",
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            store.token = response.data.token.token;

            store.user = {
              id: response.data.user.id,
              first_name: response.data.user.first_name,
              last_name: response.data.user.last_name,
              email: response.data.user.email,
              roles: response.data.user.roles,
            };
            store.roles = response.data.user.roles;
            console.log(response.data.user.roles);
            console.log(store.roles);

            const date = new Date();
            date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
            const expires = "expires=" + date.toUTCString();

            document.cookie = `_site_data=${JSON.stringify(response.data)}; ` + expires + "; path=/";
            document.cookie = `roles=${JSON.stringify(response.data.user.roles)}; ` + expires + "; path=/";
            document.cookie = `sucursal=${JSON.stringify(response.data.user.sucursal)}; ` + expires + "; path=/";

            router.push("/");
            location.reload();
          }
        });
    },
  },
};
</script>

<style scoped>
/* =============== */
/* Neumorphism UI  */
/* =============== */

.neu-bg {
  min-height: 100vh;
  background: #e9eef5;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Mantener tu ancho */
.carta {
  width: 350px;
}

/* Card neumorphism */
.neu-card {
  background: #e9eef5;
  border-radius: 26px;
  padding: 42px 34px 30px;
  box-shadow: 14px 14px 30px rgba(153, 171, 196, 0.55),
    -14px -14px 30px rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.55);
}

/* Avatar */
.neu-avatar-wrap {
  display: flex;
  justify-content: center;
  margin-top: -10px;
}

.neu-avatar {
  width: 92px;
  height: 92px;
  border-radius: 999px;
  background: #e9eef5;
  box-shadow:
    inset 5px 5px 10px rgba(153, 171, 196, 0.40),
    inset -5px -5px 10px rgba(255, 255, 255, 0.95),
    0 1px 0 rgba(255, 255, 255, 0.65);
  display: grid;
  place-items: center;
}

.neu-avatar img {
  width: 70%;
  height: auto;
  object-fit: contain;
}

/* Title / subtitle */
.neu-title {
  margin: 0;
  font-weight: 800;
  letter-spacing: 0.2px;
  color: #2a3b53;
}

.neu-subtitle {
  margin: 6px 0 0;
  color: #7b8aa0;
  font-size: 0.92rem;
}

/* Input wrappers */
.neu-input {
  position: relative;
  margin-bottom: 18px;
}

.neu-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  color: #7b8aa0;
  pointer-events: none;
}

.neu-icon svg {
  width: 18px;
  height: 18px;
}

/* Importante: esto estiliza el input REAL que renderiza tu <text-input> */


/* Button neumorphism */
.neu-btn {
  height: 52px;
  border-radius: 18px;
  border: none;
  font-weight: 700;
  letter-spacing: 0.3px;

  background: #51b6cf;
  box-shadow: 10px 10px 22px rgba(153, 171, 196, 0.55),
    -10px -10px 22px rgba(255, 255, 255, 0.9);
  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.neu-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.02);
}

.neu-btn:active {
  transform: translateY(0px);
  box-shadow: inset 8px 8px 16px rgba(0, 0, 0, 0.12),
    inset -8px -8px 16px rgba(255, 255, 255, 0.7);
}

/* Footer */
.neu-foot {
  font-size: 0.9rem;
}

.neu-muted {
  color: #7b8aa0;
}

/* Responsive */
@media (max-width: 576px) {
  .carta {
    width: 100%;
  }
  .neu-card {
    padding: 38px 22px 26px;
    border-radius: 22px;
  }
}
</style>
